import _logDebug from 'web-interactives-embed-framework/helpers/logDebug';
const logDebug = (...args) => {
  _logDebug('[GlobalIframeCommunication]', ...args);
};
import { createEventEmitter } from './EventEmitter';
// If registering handlers solely for web interactives or forms, use the
// type-narrowed variants in the projects' corresponding
// `TypedGlobalIframeCommunication` files.
export class GlobalIframeCommunication {
  constructor() {
    this.iframeCommunicators = new Map();
    this.eventEmitter = createEventEmitter();
    this.reset = () => {
      this.eventEmitter.reset();
      this.iframeCommunicators = new Map();
    };
  }
  registerHandler(event, handler) {
    this.eventEmitter.on(event, handler);
  }
  registerHandlers(handlers) {
    logDebug('Registering handlers', handlers);
    Object.keys(handlers).forEach(key => {
      const event = key;
      const handler = handlers[event];
      if (handler) {
        this.registerHandler(event, handler);
      }
    });
  }
  registerCommunicator(iframeCommunicator, id) {
    logDebug('Registering communicator', id);
    const communicatorArr = this.iframeCommunicators.get(id) || [];
    this.iframeCommunicators.set(id, [...communicatorArr, iframeCommunicator]);
  }
  removeCommunicator(id) {
    logDebug('Removing Iframe Communicator from GlobalCommunication: ', id);
    this.iframeCommunicators.delete(id);
  }
  emit(event, messagePayload) {
    logDebug('Emitting event', {
      event,
      messagePayload
    });
    this.eventEmitter.emit(event, messagePayload);
  }
  broadcast(id, message) {
    const communicatorsArr = this.iframeCommunicators.get(id);
    if (!communicatorsArr) {
      logDebug('Cannot find communcators array, not broadcasting', id, message);
      return;
    }
    logDebug('Broadcasting', communicatorsArr);
    communicatorsArr.forEach(communicator => {
      communicator.sendMessage(message);
    });
  }
  broadcastAll(message) {
    logDebug('Broadcasting', message, 'to all', this.iframeCommunicators);
    for (const [id, __] of this.iframeCommunicators) {
      this.broadcast(id, message);
    }
  }

  // Test method
}
const instance = new GlobalIframeCommunication();
export default instance;